import { useEffect, useState } from 'react';
import QRScan from '../../components/qr_scan';
import { useLocation, useNavigate } from 'react-router-dom';
import { useQuery } from '../../hook/useQuery';
import Cookies from 'js-cookie';

const PageMenuSurvey = (props) => {
  const query = useQuery();

  const navigate = useNavigate();


  return (
    <>
      <div
        className="w-full h-screen flex flex-col justify-center items-center bg-gray-200 px-5"
        style={{
          background: `url('${props?.config?.background}') no-repeat center center fixed`,
          backgroundSize: 'cover'
        }}>
        <div className="flex flex-col justify-center items-center pb-20">
          <div className="text-white font-bold mb-10 text-xl uppercase">
            {query.get('event')}
          </div>
          <div className="flex flex-col space-y-2 bg-white p-4 rounded-xl">
                  <div className="text-center uppercase text-black font-bold text-2xl mb-2">
                   SURVEY
                  </div>
                  <a
                    href={`./survey?day=1&id_gate=1`}
                    className={`uppercase min-w-[160px] px-10 py-2 rounded-lg text-white font-bold bg-purple-500 w-full text-center`}>
                    SURVEY DAY 1
                  </a>
                  <a
                     href={`./survey?day=2&id_gate=3`}
                    className={`uppercase min-w-[160px] px-10 py-2 rounded-lg text-white font-bold bg-amber-500 w-full text-center`}>
                    SURVEY DAY 2
                  </a>
                  <a
                     href={`./survey?day=3&id_gate=5`}
                    className={`uppercase min-w-[160px] px-10 py-2 rounded-lg text-white font-bold bg-green-500 w-full text-center`}>
                    SURVEY DAY 3
                  </a>


                </div>
        </div>
      </div>
    </>
  );
};

export default PageMenuSurvey;
